/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {errorMsg} from "../../../../../../../Apis/functions";
import {useDispatch, useSelector} from "react-redux";
import {ATTENDANCE_SUBVIEW_MODEL} from "../../../Model/Model";
import {DeleteItemsApi} from "../../../../../../../reduxToolkit/Commons/CommonsApi";
import {TABLES} from "../../../../../../../Apis/Tables";
import {permissionObj} from "../../../../../../../Helpers/permission";

const SpecialPermissionAssignedEmployeesApp = ({ selected, setSelected, setIsAllChecked, registerAction, setModified }) => {
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const deletePermission = DEV || permission.includes(permissionObj?.WEB_USER_SPECIAL_PERMISSION_DELETE);

    /**
     * Registers available actions based on selected items.
     * If there are selected items, enables delete action in parent context.
     */
    useEffect(() => {
        if(selected.length > 0)
            registerAction(
                ATTENDANCE_SUBVIEW_MODEL.MANAGE.SPECIAL_PERMISSION,
                { handleDelete }
            );
        else {
            registerAction(
                ATTENDANCE_SUBVIEW_MODEL.MANAGE.SPECIAL_PERMISSION,
                {}
            );
        }
    }, [selected]);

    /**
     * Handles delete action for a specific item or current selection.
     *
     * @param {Object} [item] - Optional item to delete
     * @param {string} item.userId - User ID to be deleted
     */
    const handleDelete = (item) => {
        if(item) setSelected([item.userId]);
        setDeleteModalShow(true);
    };

    /**
     * Resets selected items and the select all checkbox, and hides the delete confirmation modal.
     */
    const hide = () => {
        setSelected([]);
        if (setIsAllChecked) setIsAllChecked(false);
        setDeleteModalShow(false);
    };

    /**
     * Executes deletion of selected employees.
     *
     * Dispatches a Redux action to delete records from USER_SPECIAL_PERMISSION table.
     * On success, marks data as modified and resets state.
     * On failure, displays an error message.
     */
    const onDelete = () => {
        if(selected.length > 0 )
            dispatch(DeleteItemsApi({ tableName: TABLES.USER_SPECIAL_PERMISSION, body: selected }))
                .then(({ payload: { data: { code, success} } }) => {
                    if (success) {
                        setModified(true);
                        hide();
                    } else {
                        errorMsg(code);
                    }
                });
    }

    return {
        t,
        deletePermission,
        handleDelete,
        onDelete,
        hide,
        deleteModalShow
    }
}

export default SpecialPermissionAssignedEmployeesApp
